import { useState } from 'react';
import { frankfurtPhotos } from '@/mocks/frankfurt2026';
import PhotoLightbox from './PhotoLightbox';

export default function ArticleGallery() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const leadPhoto = frankfurtPhotos[0];
  const restPhotos = frankfurtPhotos.slice(1);

  return (
    <>
      {/* Lead frame */}
      <button
        type="button"
        onClick={() => setOpenIndex(0)}
        className="group relative block w-full aspect-[16/9] overflow-hidden rounded-2xl border border-cream-200 cursor-pointer text-left"
        aria-label="Open the lead photograph from Frankfurt Book Fair 2026"
      >
        <img
          src={leadPhoto.src}
          alt={leadPhoto.caption}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/10 to-transparent flex flex-col justify-end p-5 md:p-6">
          <div className="flex items-end justify-between gap-4">
            <p className="text-xs md:text-sm text-white/90 leading-relaxed max-w-xl">{leadPhoto.caption}</p>
            <span className="w-9 h-9 shrink-0 rounded-full bg-gold-400 flex items-center justify-center">
              <i className="ri-zoom-in-line text-navy-900 text-sm"></i>
            </span>
          </div>
        </div>
        <div className="absolute top-4 left-4 px-2.5 py-1 rounded-full bg-navy-950/60 text-[10px] font-medium text-white/90">
          Lead photograph
        </div>
      </button>

      {/* Uniform grid — 9 frames, 3 per row, no gaps */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4 mt-3 md:mt-4">
        {restPhotos.map((photo, index) => (
          <button
            key={photo.src}
            type="button"
            onClick={() => setOpenIndex(index + 1)}
            className="group relative block aspect-[4/3] overflow-hidden rounded-xl border border-cream-200 cursor-pointer text-left"
            aria-label={`Open photograph ${index + 2}: ${photo.caption}`}
          >
            <img
              src={photo.src}
              alt={photo.caption}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-4">
              <p className="text-[11px] text-white/90 leading-snug mb-2 line-clamp-3">{photo.caption}</p>
              <span className="inline-flex items-center gap-1.5 text-[10px] font-medium text-gold-300 uppercase tracking-wider">
                <i className="ri-zoom-in-line"></i>
                View photo
              </span>
            </div>
            <div className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-full bg-navy-950/60 text-[10px] font-medium text-white/90">
              {String(index + 2).padStart(2, '0')}
            </div>
          </button>
        ))}
      </div>

      <PhotoLightbox photos={frankfurtPhotos} openIndex={openIndex} onClose={() => setOpenIndex(null)} />
    </>
  );
}